import React, { useRef } from "react";
import { string } from "prop-types";

import SearchIcon from "../../atoms/icons/search-icon";
import { SearchBox } from "../../pages/search/SearchBoxBase";

import "./search-input.m.css";
import { staticTexts } from "../../utils/Translate";

const DrawForm = ({ children }) => [
  <label htmlFor="searchForm" key="1">
    {children}
  </label>,
  <button type="submit" styleName="search" key="2">
    <SearchIcon color="#0099ff" width={28} height={28} />
  </button>,
];

const SearchInput = ({ className, defaultValue = "", lang }) => {
  const textInput = useRef();
  const searchForm = useRef();

  return (
    <div styleName="container" className={className}>
      <SearchBox
        styleName="search-box"
        inputId="searchForm"
        inputClassName="search__form-input"
        template={DrawForm}
        inputRef={textInput}
        formRef={searchForm}
        placeholder={staticTexts(lang).searchBoxText}
        initValue={defaultValue}
      />
    </div>
  );
};

SearchInput.defaultProps = {
  className: "",
};

SearchInput.propTypes = {
  defaultValue: string,
  className: string,
  lang: string,
};

export default SearchInput;
